module.exports = __webpack_public_path__ + "static/media/MIX_END.0bbf56de.mp3";